module.exports = __webpack_public_path__ + "puxidefault.jpg?440b69eaf64f551aaeb059fb4b3bbbb9";